import QueueList from './QueueList';

export default QueueList;
